import { render, staticRenderFns } from "./PlaceFloorPlans.vue?vue&type=template&id=16880860&scoped=true&"
import script from "./PlaceFloorPlans.vue?vue&type=script&lang=js&"
export * from "./PlaceFloorPlans.vue?vue&type=script&lang=js&"
import style0 from "./PlaceFloorPlans.vue?vue&type=style&index=0&id=16880860&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16880860",
  null
  
)

/* custom blocks */
import block0 from "./PlaceFloorPlans.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16880860')) {
      api.createRecord('16880860', component.options)
    } else {
      api.reload('16880860', component.options)
    }
    module.hot.accept("./PlaceFloorPlans.vue?vue&type=template&id=16880860&scoped=true&", function () {
      api.rerender('16880860', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/PlaceFloorPlans/PlaceFloorPlans.vue"
export default component.exports